module.exports = __webpack_public_path__ + "img/wxfw.96d451ee.png";